// extracted by mini-css-extract-plugin
module.exports = {"Btns":"ActionBtns_Btns__3PT8T","Txt":"ActionBtns_Txt__3XDAl"};